import { useState, useEffect } from 'react';
import { dbService } from '../../fbase';

import Loading from '../../components/Loading';

import { Table } from 'react-bootstrap';

function SellerBoard() {
  const [sellers, setSellers] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    dbService.collection('distributors').onSnapshot((snapshot) => {
      const dists = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1));

      setSellers(dists);
    });
    setLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {load ? (
        <Loading />
      ) : (
        <div className="sellerboard__container">
          <div className="sellerboard__wrapper">
            <div className="sellerboard__content">
              <Table className="sellerboard__table">
                <thead>
                  <tr className="sellerboard__item">
                    <td className="sellerboard__item-name">업체명</td>
                    <td className="sellerboard__item-url">판매처</td>
                    <td className="sellerboard__item-contact">대표 연락처</td>
                    <td className="sellerboard__item-rep">대표자명</td>
                  </tr>
                </thead>
                <tbody>
                  {sellers?.map((seller) => (
                    <Distributor key={seller.id} dist={seller} />
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const Distributor = ({ dist }) => {
  return (
    <tr
      className={
        dist.active ? 'distributor__item' : 'distributor__item suspended'
      }
    >
      <td className="distributor__item-elm distributor__name">{dist.name}</td>
      <td className="distributor__item-elm distributor__url">
        {dist.active ? (
          <a href={dist.url} rel="noreferrer" target="_blank">
            바로가기
          </a>
        ) : (
          '판매중지'
        )}
      </td>
      <td className="distributor__item-elm distributor__contact">
        {dist.contact}
      </td>
      <td className="distributor__item-elm distributor__rep">
        {dist.representative}
      </td>
    </tr>
  );
};

export default SellerBoard;
